import { _ as t } from "./caml_exceptions-99f2c2ac.mjs";

import { v as n, s as i } from "./caml_option-16487d6d.mjs";

function getExn(t) {
  if (void 0 !== t) {
    return n(t);
  }
  throw {
    RE_EXN_ID: "Not_found",
    Error: new Error
  };
}

function mapWithDefaultU(t, i, a) {
  if (void 0 !== t) {
    return a(n(t));
  } else {
    return i;
  }
}

function mapU(t, a) {
  if (void 0 !== t) {
    return i(a(n(t)));
  }
}

function flatMapU(t, i) {
  if (void 0 !== t) {
    return i(n(t));
  }
}

function flatMap(n, i) {
  return flatMapU(n, t(i));
}

function getWithDefault(t, i) {
  if (void 0 !== t) {
    return n(t);
  } else {
    return i;
  }
}

function isSome(t) {
  return void 0 !== t;
}

function isNone(t) {
  return void 0 === t;
}

export { getWithDefault as a, isNone as b, mapU as c, flatMapU as d, flatMap as f, getExn as g, isSome as i, mapWithDefaultU as m };
